import { configureStore } from '@reduxjs/toolkit';
import teacherReducer from './reducers/teacherReducer';
import sessionReducer from './reducers/sessionReducer';

export default configureStore({
  reducer: {
    teacher: teacherReducer,
    session: sessionReducer,
  },
});
